import { Examples } from '@/types';

export const ExampleMStoreQuickActionsRoutes =
  process.env.NODE_ENV !== 'production'
    ? [
      {
        ...Examples.ExampleMStoreQuickActions,
        components: {
          default: () => import(/* webpackChunkName: "ExampleMStoreQuickActions" */ 
          '@/views/examples/ExampleMStoreQuickActions.vue')
        }
      }
    ]
    : [];